var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useMemo, useContext, useState } from "react";
import { LoadingOverlay } from "../components/LoadingOverlay";
var LoaderContext = createContext({
    isLoading: function (active) { },
});
export var LoaderProvider = function (_a) {
    var children = _a.children, textStyles = _a.textStyles, loadingText = _a.loadingText;
    var _b = useState(false), showLoader = _b[0], setShowLoader = _b[1];
    var value = useMemo(function () {
        var isLoading = function (active) {
            setShowLoader(active);
        };
        return {
            isLoading: isLoading,
        };
    }, []);
    return (_jsxs(LoaderContext.Provider, __assign({ value: value }, { children: [showLoader && (_jsx("div", __assign({ className: "fixed top-0 right-0 bottom-0 left-0 z-145 w-full h-full" }, { children: _jsx(LoadingOverlay, { loadingText: loadingText, textStyles: textStyles }) }))), children] })));
};
export var useLoader = function () { return useContext(LoaderContext); };
